
export const fundationData =  [
         
    {
        name: "Fundacja Wspieraj",
        description:" Fundacja pomaga potrzebującym",
        collect: "ubrania, jedzenie, meble, AGD",
    },
    {
        name: "Fundacja Bez domu",
        description: "Organizacja pomaga osobom bez dachu nad głową",
        collect: "ubrania, jedzenie, kurtki, koce",
    },
    {
        name: "Fundacja 'Dobry Sąsiad'",
        description: "Organizacja pomaga potrzebującym w twojej okolicy",
        collect: "ubrania, jedzenie, meble, AGD"
    },
    {
        name: "Fundacja Bądź Eko",
        description: "Oddawaj nie potrzebne rzeczy, nie twórz śmieci",
        collect: "ubrania, jedzenie, meble, AGD"
    },
    {
        name: "Fundacja Zabrze Razem",
        description: "Miejska fundacja pomocy biednym mieszkańcom",
        collect: "ubrania, meble, AGD"
    },
    {
        name: "Fundacja Reakcja",
        description: "Fundacja zbiera rzeczy i oddaje potrzebującym",
        collect: "ubrania, jedzenie, meble, AGD"
    },
    {
        name: "Fundacja Zmiana",
        description: "Poprawiamy życie biedniejszym",
        collect: "ubrania, jedzenie, meble"
    },
    {
        name: "Fundacja Pod Dębem",
        description: "Organizacja pomaga walczyś o środowisko",
        collect: "RTV, AGD, Meble"
    },
    {
        name: "Fundacja Mama Sama",
        description: "Organizacja pomaga samotnym matkom",
        collect: "ubrania, rzeczy dla dzieci, meble"
    },
]

        
export const organizationData =  [
         
                {
                    name: "Organizacja Wspieraj Ekologi",
                    description: "Organizacja pomaga walczyś o środowisko",
                    collect: "ubrania, jedzenie, meble, AGD",
                },
                {
                    name: "Organizacja Bezdomnym",
                    description: "Organizacja pomaga osobom bez dachu nad głową",
                    collect: "ubrania, jedzenie, kurtki, koce",
                },
                {
                    name: "Organizacja 'Dobry Sąsiad'",
                    description: "Organizacja pomaga potrzebującym w twojej okolicy",
                    collect: "ubrania, jedzenie, meble, AGD"
                },
                {
                    name: "Organizacja Zielona Ekologia",
                    description: "Organizacja pomaga walczyś o środowisko",
                    collect: "ubrania, jedzenie, meble, AGD"
                },
                {
                    name: "Organizacja Wspieraj Ekologię",
                    description: "Organizacja pomaga walczyś o środowisko",
                    collect: "ubrania, jedzenie, meble, AGD"
                },
                {
                    name: "Organizacja POMOC TERAZ",
                    description: "Organizacja pomaga walczyś o środowisko",
                    collect: "ubrania, jedzenie, meble, AGD"
                },
]



export const charrityData = [

                {
                    name: "Zbiórka 'Nie nosisz? - Oddaj!' ",
                    description: "Oddajemy nie noszone ubrania potrzebującym",
                    collect: "ubrania"
                },
                {
                    name: "Zbiórka 'Graty to Skarby' ",
                    description: "Zbieramy niepotrzebny sprzęt i urządzenia domowe",
                    collect: "meble, AGD"
                },
                {
                    name: "Zbiórka Nie wyrzucaj elektroniki",
                    description: "Zbieramy elektronikę i przekazujemy dalej",
                    collect: " RTV, AGD, stare komputery"
                },
                
]

        
        

